import { createAnalyticsStore } from "@/store/Analytic/create-chart-store";

export const useNewsStatDynamicRubricStore = createAnalyticsStore(
  "newsStatDynamicRubricss",
  "Analytics/rubric/dynamics/:projectId"
);